import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { RootState } from 'store'
import { DashboardCard } from 'styling/GlobalStyles'
import { tokens } from 'styling/tokens'
import { IWidget } from 'types/dashboard.interface'
import { WidgetHeader, WidgetTitle } from 'pages/HrDashboard/Widgets/widgetParts.styled'
import { WidgetBody } from 'pages/HrDashboard/hrLayout.styled'
import { DistributionDonut } from './DistributionDonut'
import { machineryStatusesData } from '../dashboardData'

const COLORS = [
  tokens.status.success.fg,
  tokens.accent.base,
  tokens.status.danger.fg,
  tokens.status.warning.fg,
  tokens.status.info.fg,
  tokens.status.neutral.fg,
  tokens.text.muted,
]

export const MachineryWidget = ({ modalOpen }: IWidget) => {
  const navigate = useNavigate()
  const { machinery } = useSelector((state: RootState) => state.dashboard)

  const rows = machineryStatusesData.map((m, index) => ({
    label: m.name,
    value: machinery?.machineStatuses?.find((s) => s.status === m.id)?.count ?? 0,
    color: COLORS[index % COLORS.length],
  }))

  return (
    <DashboardCard
      width='1fr'
      onClick={() => !modalOpen && navigate('/dashboard/machines')}
      style={{ height: '100%', cursor: modalOpen ? 'grab' : 'pointer' }}
    >
      <WidgetHeader>
        <WidgetTitle>Machinery</WidgetTitle>
      </WidgetHeader>
      <WidgetBody>
        <DistributionDonut rows={rows} centerLabel='machines' />
      </WidgetBody>
    </DashboardCard>
  )
}
